import { render } from "./circle-xmark.vue?vue&type=template&id=ef062e6c"
const script = {}

import exportComponent from "/var/www/pases-h2o/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__